// src/components/ui/SupplierProgramsHeader.jsx
import React from 'react';

const SupplierProgramsHeader = ({
  title    = 'תוכניות גפ״ן',
  subtitle = 'התוכניות החינוכיות שמרכז הלמידה מנהל מול גפ״ן ובתי הספר המשתתפים',
}) => {
  return (
    <section className="mx-auto max-w-7xl px-2 sm:px-4 md:px-6 lg:px-8 py-3" dir="rtl">
      <div className="relative overflow-hidden rounded-2xl sm:rounded-3xl">
        <div className="absolute inset-0 bg-gradient-to-br from-indigo-50 via-purple-50 to-blue-50" />

        <div className="relative bg-white/80 backdrop-blur-xl border border-white/60 rounded-2xl sm:rounded-3xl p-4 sm:p-5 lg:p-6 shadow-2xl shadow-indigo-100/50">
          <div className="flex items-center gap-3 sm:gap-4">

            {/* Icon */}
            <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 rounded-xl sm:rounded-2xl bg-gradient-to-br from-indigo-500 to-purple-600 text-white flex items-center justify-center shadow-md">
              <svg
                viewBox="0 0 24 24"
                className="w-5 h-5 sm:w-6 sm:h-6"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                aria-hidden="true"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 12l8-4.5M12 12v9M12 12L4 7.5" />
              </svg>
            </div>

            {/* Text */}
            <div className="min-w-0 flex-1">
              <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold bg-gradient-to-r from-gray-900 via-indigo-800 to-purple-800 bg-clip-text text-transparent leading-tight">
                {title}
              </h1>
              {subtitle && (
                <p className="text-sm sm:text-base text-gray-600 mt-0.5 sm:mt-1 line-clamp-2 sm:truncate">
                  {subtitle}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SupplierProgramsHeader;